'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import OCAuthSDK, { type Scope } from '@openclassrooms/auth-sdk';
import { CurrentUserContextProvider, removeCachedCurrentUser } from '@openclassrooms/data-connect-web/users';
import { useConfig } from '@openclassrooms/utils/ConfigProvider';
import { deleteCookie, getCookies } from '@openclassrooms/utils/cookies/services';
const CONNECTED_SCOPES: Scope[] = ['user_email', 'user_public_profile', 'user_learning_activity', 'learning_content', 'user_birth_information', 'user_communications', 'user_calendar', 'organization', 'user_interest', 'openclassrooms_client'];
const COOKIES_KEY = {
  ACCESS_TOKEN: 'access_token',
  ACCESS_TOKEN_EXPIRES_IN: 'access_token_expires_in'
} as const;
type CurrentUserContextProviderProps = React.ComponentProps<typeof CurrentUserContextProvider>;
export default function CurrentUserProviderWrapper(t0) {
  const $ = _c(7);
  const {
    user,
    children
  } = t0;
  const {
    config
  } = useConfig();
  let t1;
  let t2;
  if ($[0] !== config) {
    t1 = () => {
      const cookies = getCookies();
      const accessToken = cookies[COOKIES_KEY.ACCESS_TOKEN];
      if (!accessToken) {
        return;
      }
      const sdk = new OCAuthSDK({
        clientId: config.openclassrooms.api.anonymous.client_id,
        clientSecret: config.openclassrooms.api.anonymous.client_secret,
        rootUrl: config.openclassrooms.api.urls.proxy || config.openclassrooms.api.urls.root,
        authorizeUrl: config.openclassrooms.api.urls.authorize
      });
      sdk.setOauth2Tokens({
        accessToken,
        expiresIn: Number(cookies[COOKIES_KEY.ACCESS_TOKEN_EXPIRES_IN]) || 0,
        scopes: CONNECTED_SCOPES,
        grantType: "implicit"
      });
      [COOKIES_KEY.ACCESS_TOKEN, COOKIES_KEY.ACCESS_TOKEN_EXPIRES_IN].forEach(_temp);
    };
    t2 = [config];
    $[0] = config;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(_temp3, t3);
  let t4;
  if ($[4] !== children || $[5] !== user) {
    t4 = <CurrentUserContextProvider user={user}>{children}</CurrentUserContextProvider>;
    $[4] = children;
    $[5] = user;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp3() {
  const run = _temp2;
  run();
}
async function _temp2() {
  const currentUrl = new URL(window.location.href);
  if (!currentUrl.searchParams.has("hasCurrentUserBeenEdited")) {
    return;
  }
  currentUrl.searchParams.delete("hasCurrentUserBeenEdited");
  const search = currentUrl.searchParams.toString();
  const nextUrl = `${currentUrl.pathname}${search ? `?${search}` : ""}${currentUrl.hash}`;
  window.history.replaceState(window.history.state, "", nextUrl);
  try {
    await removeCachedCurrentUser();
  } catch {}
}
function _temp(cookieKey) {
  deleteCookie(cookieKey);
}